// extracted by mini-css-extract-plugin
module.exports = {"footnote":"footnote_footnote__3PPgS","fade-in":"footnote_fade-in__2dL4K"};